import { useLayoutEffect, useRef } from 'react';

const AssistantTextBubble = ({ children, className = '' }) => {
    const bubbleRef = useRef(null);

    useLayoutEffect(() => {
        const bubble = bubbleRef.current;
        const parent = bubble.parentElement;
        const range = document.createRange();
        if (!parent || typeof range.getClientRects !== 'function') return;

        let active = true;
        let parentWidth;
        const fitToText = () => {
            if (!active) return;

            // Wrap at the available width first, then hug the longest rendered line.
            bubble.style.width = '';
            range.selectNodeContents(bubble);
            const rects = Array.from(range.getClientRects()).filter(rect => rect.width > 0);
            if (!rects.length) return;

            const bounds = bubble.getBoundingClientRect();
            const paddingRight = parseFloat(window.getComputedStyle(bubble).paddingRight) || 0;
            // A line may contain several fragments when it includes source links.
            const textRight = Math.max(...rects.map(rect => rect.right));
            const width = Math.min(bounds.width, Math.ceil(textRight - bounds.left + paddingRight));
            bubble.style.width = `${width}px`;
        };

        fitToText();
        const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(([entry]) => {
            if (entry.contentRect.width === parentWidth) return;
            parentWidth = entry.contentRect.width;
            fitToText();
        }) : null;
        observer?.observe(parent);
        window.addEventListener('resize', fitToText);
        document.fonts?.ready.then(fitToText);
        document.fonts?.addEventListener('loadingdone', fitToText);

        return () => {
            active = false;
            observer?.disconnect();
            window.removeEventListener('resize', fitToText);
            document.fonts?.removeEventListener('loadingdone', fitToText);
        };
    }, [children, className]);

    return (
        <div ref={bubbleRef} className={`chatThreadText chatThreadAssistantTextBubble ${className}`}>
            {children}
        </div>
    );
};

export default AssistantTextBubble;
